<template>
    <div class="tabs">
      <div class="tab-headers">
          <button
              v-for="(tab, index) in tabs"
              :key="index"
              :class="{ active: activeTab === index }"
              @click="selectTab(index)"
          >
              {{ tab.name }}
          </button>
      </div>

      <div class="tab-content">
          <div v-if="tabs[activeTab]">
              <component :myPersonId="myPersonId" :is="tabs[activeTab].component"></component>
          </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import ContactsTab from './ContactsTab.vue';
import ConversationsTab from './ConversationsTab.vue';
export default {
  name: 'v-company-conversation',
  components: {
      ContactsTab,
      ConversationsTab
  },
  props: ['myPersonId', 'otherPersonId'],
  data: function() {
    return {
      isLoadingBefore: false,
      isLoadingSince: false,
      hasLoadingBeforeError: false,
      messages: [],
      patients: [],
      newMessageBody: null,
      pollingInterval: 4000,
      isPollingPaused: false,
      hasSendMessageError: false,
      searchQuery: "",
      items: [],
      activeTab: 0,
      tabs: [
          { name: "Conversations", component: "ConversationsTab" },
          { name: "Contacts", component: "ContactsTab" }
      ],
    };
  },
  mounted() {
    //this.getAllUsers();

    //this.$el.querySelector('.messages').addEventListener('scroll', this.handleScroll);
  },
  methods: {
      selectTab(index) {
          this.activeTab = index;
      },
    handleScroll() {
      if (this.$el.querySelector('.messages').scrollTop == 0) {
        if (this.messages.length) {
          this.getBefore(this.messages[0]);
        }
      }
    },
  //   getAllUsers() {
  //     this.isPollingPaused = true;
  //     axios
  //       .get(`/api/v1/messages/users`)
  //       .then((response) => {
  //           console.log(response)
  //       })
  //       .catch(
  //         function(error) {
  //           console.log(error)
  //         }.bind(this)
  //       );
  //   },
    returnList(){
      this.messages = [];
    },
    openConversation(patient_id){
      this.isPollingPaused = true;
      axios
        .get(`/api/v1/messages/patient/${patient_id}`)
        .then((response) => {
          if (response.data.data) {
            let results = response.data.data;
            
            let newResults = results.map((result)=> {
              if(result.sender.id == this.myPersonId){
                result.sender.firstName = "Support"
                result.sender.lastName = "";
              }
              return result;
            });
            
            this.messages = newResults;
            this.messages.reverse();
          }
          this.resetScrollPosition();
          this.isPollingPaused = false;
        })
        .catch(
          function(error) {
            this.isPollingPaused = false;
          }.bind(this)
        );
    },
    resetScrollPosition() {

      setTimeout(() => {
        var container = this.$el.querySelector('.messages');
        if(container){
          this.$nextTick(() => {
            container.scrollTop = container.scrollHeight;
          });
        }
      }, 1);
    },
    messageIsMine(message) {
      return message.sender.id == this.myPersonId;
    },
    getAvatarForMessage(message) {
      if (message.sender.avatar) {
        return message.sender.avatar;
      }
      return '/images/default-avatar.png';
    },
    getLatestMessageId() {
      if (this.messages.length) {
        return this.messages[this.messages.length - 1].id;
      }
    },
    sendNewMessage() {
      this.isLoadingSince = true;
      this.hasSendMessageError = false;
      this.resetScrollPosition();

      axios
        .post('/api/v1/messages', { body: this.newMessageBody, re: this.getLatestMessageId()})
        .then((response) => {
          this.isLoadingSince = false;

          let data = response.data.data;
          
          data.sender.firstName = "Support";
          data.sender.lastName = "";

          this.messages.push(data);

          this.resetScrollPosition();
        })
        .catch(
          function(error) {
            this.hasSendMessageError = true;
            this.isLoadingSince = false;
          }.bind(this)
        );
    },
    detectEnter(e) {
      if (e.keyCode === 13) {
        this.newMessageBody = this.newMessageBody.trim();
        if (this.newMessageBody) {
          this.sendNewMessage();
          this.newMessageBody = '';
        }
      }
    },
    localTime(datetime) {
      datetime = datetime.replace(/\.000000/, '');
      let utcDate = moment.utc(datetime);
      return moment(utcDate)
        .local()
        .calendar('', { sameElse: 'M/D/YYYY, h:mm A' });
    },
  },
};
</script>

<style type="sass" scoped>
  .return-list{
      padding-bottom: 10px;
      display: block;
      border-bottom: 1px solid #ccc;
      cursor: pointer;
  }

  .tab-headers button{
      width: 50%;
      border: 1px solid #ddd;
      background: #ccc;
  }
  .active{
      background: #eee !important;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/CompanyConversation.vue